module.exports = __webpack_public_path__ + "static/laura-keisler-15f58ef8c153bc7f5fa9efcfc4574a91.jpg";